import React from 'react';
import { ScrollParallax } from 'react-just-parallax';
import DefaultButton from './DefaultButton';

function Minimal({ title, content, image, buttonText, sideSection, extraClass, containerWidth, imageMobileHidden }) {

    return (
        <>
            <div className='relative z-20 h-lvh overflow-hidden'>
                {/* <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05"> */}
                    <img src={image} alt={title} 
                    className={`absolute top-0 left-0 w-full h-full object-cover ${imageMobileHidden ? 'hidden md:block' : ''}`} style={{ transform: 'scale(1.2)' }} />
                {/* </ScrollParallax> */}
                <div className={`absolute top-0 left-0 w-full h-full flex items-center 
                    ${imageMobileHidden ? 'md:bg-black/60 bg-white' : 'bg-black/60'}
                `}/>

                <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 ${containerWidth}`}>                
                    <div className={`flex flex-col md:text-white
                        ${sideSection === 'right' ? 'items-end text-start' : sideSection === 'left' ? 'items-start text-start' : 'justify-center text-center items-center'}`}>
                        <div className={`w-full xl:w-2/3 ${extraClass} ${sideSection ? 'mx-[5%] md:mx-0' : 'mx-auto'}`}>
                            <h2 className="lg:text-5xl text-4xl text-mcare-green font-semibold md:drop-shadow-lg text-balance panoragraf-light " data-aos="fade-up" data-aos-duration="1000">
                                {title}
                            </h2>
                            {content}
                            {buttonText && <DefaultButton text={buttonText} link="/tecnologie" buttonClass="lg:w-full xl:w-1/2" data-aos="fade-up" data-aos-duration="1000"/>}
                        </div>
                    </div>  
                </div>
            </div>
        </>
    );
}

export default Minimal;
